import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../../utils/propUtils';
import VeltCommentDialogAgentSuggestionMenuContentItemWireframe from './VeltCommentDialogAgentSuggestionMenuContentItemWireframe/VeltCommentDialogAgentSuggestionMenuContentItemWireframe';
var VeltCommentDialogAgentSuggestionMenuContentWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-agent-suggestion-menu-content-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogAgentSuggestionMenuContentWireframe.Item = VeltCommentDialogAgentSuggestionMenuContentItemWireframe;
export default VeltCommentDialogAgentSuggestionMenuContentWireframe;
